import { useAllowedActions } from '../../authentication/use-allowed-actions';
import { ResourceOperations, ResourceTypes } from '../../authentication/resources';

// Mirrors the ResourceAccess attributes on the attendance endpoints in Jobcenter.Desktop.BFF
export function useAttendanceRights() {
  const allowedActions = useAllowedActions();
  const isAllowed = (resourceType: string, resourceOperation: string) => allowedActions.isAnyAllowed([{ resourceType, resourceOperation }]);

  const canReadAttendance = isAllowed(ResourceTypes.Attendance, ResourceOperations.Read);
  const canWriteAttendance = isAllowed(ResourceTypes.Attendance, ResourceOperations.Write);
  const canReadEnrollment = isAllowed(ResourceTypes.AttendanceEnrollment, ResourceOperations.Read);
  const canWriteEnrollment = isAllowed(ResourceTypes.AttendanceEnrollment, ResourceOperations.Write);
  const canReadProtocol = isAllowed(ResourceTypes.AttendanceProtocol, ResourceOperations.Read);
  const canWriteProtocol = isAllowed(ResourceTypes.AttendanceProtocol, ResourceOperations.Write);
  const canWriteFacility = isAllowed(ResourceTypes.AttendanceFacility, ResourceOperations.Write);

  return {
    canSeeCourses: canReadAttendance,
    canCreateCourse: canWriteAttendance,
    canEditCourse: canWriteAttendance,
    canDeleteCourse: canWriteAttendance,
    canCreateLesson: canWriteAttendance,
    canEditLesson: canWriteAttendance,
    canDeleteLesson: canWriteAttendance,

    canSeeEnrollments: canReadEnrollment,
    canEnrollCitizen: canWriteEnrollment,
    canEditEnrollment: canWriteEnrollment,
    canEditAttendanceNote: canWriteEnrollment,

    canSeeProtocol: canReadProtocol || canWriteProtocol,
    canEditProtocol: canWriteProtocol,
    hasOnlyProtocolAccess: !canReadAttendance && canWriteProtocol,

    canEditClassrooms: canWriteFacility,
    canEditEducators: canWriteFacility,
    canEditRegistrationCounters: canWriteFacility,

    canImportAttendance: isAllowed(ResourceTypes.AttendanceImport, ResourceOperations.Write),
  };
}
